export default {
  name: 'BccCollapseTransition',
  functional: true,
  render: function (createElement, context) {
    var data = {
      on: {
        beforeEnter: function (el) {
          el.className += ' collaspe-transition'
          el.style.height = '0px'
          el.style.overflow = 'hidden'
        },
        enter: function (el) {
          el.style.height = el.scrollHeight + 'px'
        },
        afterEnter: function (el) {
          el.className = el.className.replace(' collaspe-transition', '')
        },
        beforeLeave: function (el) {
          el.style.height = '0px'
          el.style.overflow = 'hidden'
          el.className += ' collaspe-transition'
        },
        afterLeave: function (el) {
          el.className = el.className.replace(' collaspe-transition', '')
        }
      }
    }
    return createElement('transition', data, context.children)
  }
}
